
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-cloud-lightning",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-cloud-lightning"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 16.9A5 5 0 0018 7h-1.26a8 8 0 10-11.62 9"}}),_c('path',{attrs:{"d":"M13 11l-4 6h6l-4 6"}})])
          )
        }
      }
    